<div *ngIf="pdfLoadFailed">
  <p>Der Link funktioniert nicht. Hinweis: Er könnte abgelaufen sein.</p>
</div>
<div *ngIf="!pdfLoadFailed">
  <div *ngIf="pdfUrl" style="height: 100vh; width: 100%;">
    <iframe [src]="pdfUrl" width="100%" height="100%"></iframe>
  </div>
</div>
